import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';

import { AuraAuthService } from '@digital-platform/aura-authentication/services';
import { CtaButtonComponent } from '@digital-platform/rs-cms/feature-ptypes';
import { PageMetaData } from '@digital-platform/rs-meta/domain';
import { MetaDataService } from '@digital-platform/rs-meta/services';
import { TranslationLoaderService } from '@digital-platform/rs-shared/services';
import { SafeHtmlPipe } from '@digital-platform/rs-shared/ui';
import { IconComponent } from '@digital-platform/rs-shared/ui-brand';

@Component({
  selector: 'digital-platform-auth',
  standalone: true,
  providers: [TranslatePipe],
  imports: [
    CommonModule,
    CtaButtonComponent,
    IconComponent,
    TranslateModule,
    SafeHtmlPipe,
  ],
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit {
  private auraAuthService = inject(AuraAuthService);
  private metaDataService = inject(MetaDataService);
  private translationLoaderService = inject(TranslationLoaderService);

  private route = inject(ActivatedRoute);
  public page: 'login' | 'signup' = 'login';
  public titleText = '';
  public descriptionText = '';
  public buttonText = '';
  public queryParams: Params = {};
  public alertMessage = '';

  ngOnInit() {
    this.route.data.subscribe((data) => {
      this.page = data['page'];

      if (this.page === 'login') {
        this.titleText = 'Login';
        this.descriptionText =
          'Log In to access your Republic Services Online Account';
        this.buttonText = 'Login';
      }

      if (this.page === 'signup') {
        this.titleText = 'Sign Up';
        this.descriptionText = "Don't have an account?";
        this.buttonText = 'Sign Up';
      }

      //set the SEO meta data information
      this.translationLoaderService
        .getTranslation('en')
        .subscribe((translationData) => {
          this.alertMessage = translationData['MR.ACCOUNT.LOGIN.ALERT_BANNER'];
          const currentPageMetaData: PageMetaData = {
            title:
              this.page === 'signup'
                ? translationData['SIGNUP.META.TITLE']
                : translationData['LOGIN.META.TITLE'],
            description:
              this.page === 'signup'
                ? translationData['SIGNUP.META.DESCRIPTION']
                : translationData['LOGIN.META.DESCRIPTION'],
            coveo_category: this.page,
            canonical_url:
              this.page === 'signup'
                ? translationData['SIGNUP.META.CANONICAL']
                : translationData['LOGIN.META.CANONICAL'],
          };

          this.metaDataService.setMetaData(currentPageMetaData);
        });
    });
  }

  // We can use dynamic redirects in v1 but not with Auth0 in v2 so we need to hardcode the redirect here - otherwise we need to manually add all the possible redirect urls in the auth0 tenant application config
  universalLoginAndSignup() {
    // Has to be passed in so we can return the user to referrer from /app-switcher redirects
    const redirectPath =
      this.route.snapshot.queryParams['redirectPath'] ||
      this.route.snapshot.queryParams['redirectUrl'];

    if (this.page === 'login') {
      this.auraAuthService.login();
    } else if (this.page === 'signup') {
      this.auraAuthService.signup(
        {
          redirectUrl: '/app-switcher',
        },
        { appState: { redirectUrl: redirectPath } }
      );
    }
  }
}
